import Form from './form';
import FormItem from './form-item';
import useForm from './use-form';
import FormInstance from './form-instance';
var DefaultForm = Form;
DefaultForm.Item = FormItem;
DefaultForm.useForm = useForm;
DefaultForm.FormInstance = FormInstance;
export default DefaultForm;
//# sourceMappingURL=index.js.map